export default "__VITE_ASSET__ClCeFle5__"